class SwmRegionSelector extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('#swm-region-button');
    this.panel = this.querySelector('#swm-region-panel');
    if (!this.button || !this.panel) return;

    this.button.addEventListener('click', () => this.toggle());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close(true);
    });

    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.contains(e.target)) this.close(false);
    });
  }

  get isOpen() {
    return this.button.getAttribute('aria-expanded') === 'true';
  }

  toggle() {
    if (this.isOpen) {
      this.close(false);
    } else {
      this.open();
    }
  }

  open() {
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
    const first = this.panel.querySelector('.swm-region__option');
    if (first) first.focus();
  }

  close(returnFocus) {
    this.panel.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
    if (returnFocus) this.button.focus();
  }
}

if (!customElements.get('swm-region-selector')) {
  customElements.define('swm-region-selector', SwmRegionSelector);
}
